import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Phineas extends Lit3formBlock {
  static get characterName() {
    return 'phineas';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid phineas-layout">
          ${this.headerHTML} ${this.cardsHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    if (!this.headerText && !this.descriptionText) return html``;

    return html`
      <block-intro
        class="intro"
        header=${this.content.header || ''}
        description=${this.content.description || ''}
      ></block-intro>
    `;
  }

  get cardsHTML() {
    if (!this.imagesArr.length) return html``;

    return html`
      <div class="cards">
        ${this.imagesArr.map(i => this.cardHTML(i[1]))}
      </div>
    `;
  }

  cardHTML(image) {
    return html`
      <div class="card">
        <div class="card-image">
          <img src=${this.imageUrl(image)} alt="" />
        </div>
        ${image.title
          ? html`
              <h3 class="card-title">
                ${unsafeHTML(this.withLineBreaks(image.title))}
              </h3>
            `
          : html``}
        ${image.description
          ? html`
              <p class="card-description">
                ${unsafeHTML(this.withLineBreaks(image.description))}
              </p>
            `
          : html``}
        ${image.text && image.url
          ? html`
              <cta-text
                cta-data=${this.ctaData(image)}
                .ctaAnalyticsData=${analyticsCtaDataObject(
                  { ...image, destinationUrl: image.url },
                  this.headerText
                )}
              ></cta-text>
            `
          : html``}
      </div>
    `;
  }

  ctaData(card) {
    return JSON.stringify({
      url: card.url || '',
      text: card.text || '',
    });
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 600);
  }
}
Phineas.defineElement();
